import styled from "styled-components";
import { Typography, Button, Col } from "antd";

export const Title = styled(Typography.Title)`
  && {
    font-size: 36px;
    font-weight: 700;
  }
`;

export const StyledButton = styled(Button)`
  margin: 8px 6px;
  width: 96px;
`;

export const ButtonContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: center;
  }
  > .ant-form-item {
    margin-bottom: unset;
  }
`;